import React, { FC } from "react";

import { defineMessages, useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { Alert } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";
import SettingPath, { OrganizationDetailsTabs } from "@app/enum/settings/SettingPath";

import styles from "./CustomerFaceTimeAlert.module.scss";

const messages = defineMessages({
  description: {
    id: "dashboard.addEditCard.preview.customerFaceTime.alert.description",
    defaultMessage:
      "Verified customer face time reports are only compatible with organizations using “Two-Step” Check-ins. {isOwner, select, true {You can enable this via <a>Organization Settings</a>} other {Reach out to your administrator to opt in to this feature}}.",
    description: "Customer facetime not enabled alert description",
  },
  title: {
    id: "dashboard.addEditCard.preview.customerFaceTime.alert.title",
    defaultMessage: "Want to start tracking in-person duration?",
    description: "Customer facetime not enabled alert title",
  },
});

export interface CustomerFaceTimeAlertProps {
  isOwner?: boolean;
}

const CustomerFaceTimeAlert: FC<CustomerFaceTimeAlertProps> = ({ isOwner }) => {
  const intl = useIntl();

  return (
    <Alert
      className={styles.container}
      message={
        <div className={styles.message}>
          <span className={styles.title}>{intl.formatMessage(messages.title)}</span>
          <span>
            {intl.formatMessage(messages.description, {
              a: (text) => (
                <Link
                  target="_blank"
                  to={`${Path.SETTINGS}/${SettingPath.ORGANIZATION_DETAILS}/${OrganizationDetailsTabs.ACTIVITIES}`}
                >
                  {text}
                </Link>
              ),
              isOwner,
            })}
          </span>
        </div>
      }
      showIcon
      type="warning"
    />
  );
};

export default CustomerFaceTimeAlert;
